import React from 'react'
import NavBar from '../Components/NavBar'
import image2 from '../Images/herosec1.png'
import orna1 from '../Images/ornament1.png'
import orna2 from '../Images/ornament2.png'
import image3 from '../Images/download1.png'
import image4 from '../Images/download2.png'
import image5 from '../Images/download3.png'

import download1 from '../Images/web.webp'
import download2 from '../Images/android.png'
import download3 from '../Images/ios.png'
import download4 from '../Images/windows.png'

import wanadamu1 from '../Images/wanadamu5.png'
import wanadamu2 from '../Images/wanadamu2.png'
import wanadamu3 from '../Images/wanadamu3.png'
import wanadamu4 from '../Images/wanadamu7.png'
import wanadamu5 from '../Images/wanadamu6.png'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faBriefcase, faFaceSmile, faGift, faLocationDot, faMapLocation, faPlay, faRightLeft, faRightLong} from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import {
  faPhone,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faLinkedinIn,
  faTiktok,
} from '@fortawesome/free-brands-svg-icons';




function Home() {
  return (
    <div>
      <NavBar/>

      <section className='heroSect'>
        <div className='heroSec1'>
          <p className="text-muted">Hi, there!</p>
           <h1 className="display-5 fw-bold">
            TURN WALK-INS INTO
            <span className="text-success"> REPEAT CUSTOMERS</span>
          </h1>
          <p className="text-muted mt-3">Reward your customers every time they engage. With Kuza Points, businesses like yours grow stronger communities, increase retention, and keep customers coming back</p>
          <div className='heroSec1ButtonCont'>
            <Link className="btn px-4 py-2 rounded-pill mt-3 heroBtn" to="/dashboard">Access Dashboard</Link>
            <Link className='menuItemHome' to="/signin">Get Started for free</Link>
          </div>

        </div>

        <div className='heroSec2'>
          <img src={orna1} className='orna1' alt="" />
          <img src={image2} className='heroImage' alt="" />
          <img src={orna2} className='orna2' alt="" />

          <div className='heroSec2div1'>
            <div className='heroSec2Div1Icon'><FontAwesomeIcon icon={faBriefcase}/></div>
            <div className='heroSec2div1Divs'>
              <h6>900+</h6>
              <p className="text-muted small">Businesses Using Kuza Points</p>
            </div>
          </div>

          <div className='heroSec2div2'>
            <div className='heroSec2Div1Icon'><FontAwesomeIcon icon={faGift}/></div>
            <div className='heroSec2div1Divs'>
              <h6>60%</h6>
              <p className="text-muted small">Average Customer Retention</p>
            </div>
          </div>

          <div className='heroSec2div3'>
            <div className='heroSec2Div1Icon'><FontAwesomeIcon icon={faFaceSmile}/></div>
            <div className='heroSec2div1Divs'>
              <h6>30%</h6>
              <p className="text-muted small">Boost in Repeat Sales</p>
            </div>
          </div>
        </div>
      </section>


      <section className='aboutUsSec' id='about'>
        <img src={image3} className='aboutUsSecImage1' alt="" />
        <img src={image4} className='aboutUsSecImage2' alt="" />
        <div className='aboutseChild'>
          <div className='aboutseChild1'>
             <h1>About <br />Us</h1>
            <p>We are a digital loyalty and customer rewards platform designed to help businesses of all sizes attract, retain, and reward customers. Our system enables businesses to issue loyalty points to customers based on purchases or engagement, which can later be redeemed for products, services, or discounts. We serve a wide range of industries, including retail, hospitality, wellness, automotive, and more.</p>
            <p>The platform also offers tools for customer relationship management, insights and analytics, and personalized marketing, helping businesses increase repeat purchases and build lasting customer relationships.</p>
            <p>This platform was built at Ubunifu Lab, the Centre for AI Research and Development at Ubunifu College. Whether you’re running a café, a retail store, a salon, or a service brand, we give you the tools to turn first-time buyers into lifelong fans through a loyalty system</p>
          </div>
          <div className='aboutseChild2'>
            <h1>About <br />Us</h1>
            {/* <h1 className='text-uppercase'>It’s not just about points, it’s about connection. We give businesses an easy way to keep customers coming back, increase spending, and build brand love.</h1> */}
          </div>
        </div>
          <img src={image5} className='aboutUsSecImage3' alt="" />
      </section>

      <section className='features' id='features'>

        <div className='features1'>
          <div className='features1Child card p-4'>
            <h1>1. Sign Up Your Business</h1>
            <p className='text-muted'>Create an account and launch your loyalty program in minutes, no technical skills needed. Kuza Points works seamlessly on web, Android (phone & tablet), and desktop (Mac & Windows), so you can manage rewards from anywhere. Best part? Your customers don’t need to download any app or sign up for any service, they earn and redeem points effortlessly via SMS.</p>
            <Link className="btn px-4 py-2 rounded-pill mt-3 heroBtn" to="/signin">Sign up your Business</Link>
          </div>
          <div className='features1Child23'>
            <img src={wanadamu1} alt="" />
          </div>
        </div>

        <div className='features1'>
          <div className='features1Child22 d-none d-lg-block'>
            <img src={wanadamu2} alt="" />
          </div>
          <div className='features1Child3 card p-4'>
            <h1>2. Reward Your Customers</h1>
            <p  className='text-muted'>Give a point every time a customer shops, dines, or uses your service and instantly notify them via SMS with the points awarded, their value, and their updated balance. Kuza Points makes it easy to track, manage, and reward repeat customers in real time. Whether you’re running a café, salon, retail store, or service business, rewarding loyalty is as simple as tapping a button. You decide how much your points are worth. Your rewards, your rules.</p>
            <Link className="btn px-4 py-2 rounded-pill mt-3 heroBtn" to="/signin">Reward your Customers</Link>
          </div>
        </div>

        <div className='features1'>
          <div className='features1Child  card p-4'>
            <h1>3. Customers Redeem Points</h1>
            <p  className='text-muted'>Give your customers the joy of earning something real.</p>
            <p  className='text-muted'>As they accumulate loyalty points, they can redeem them for discounts, free services, or special rewards you define. Whether it’s KES off their next purchase, a freebie after several visits, or a premium upgrade, Kuza Points makes redemption seamless, secure, and instant.</p>
            <p  className='text-muted'>To redeem, simply enter the customer’s phone number in the system. Kuza Points will instantly show their available balance and its worth. A prompt is then sent to the customer via SMS with a unique OTP. The customer shares this OTP with your staff to confirm the redemption, only then are the points officially deducted.</p>
            <p  className='text-muted'>And every time they redeem, they receive an SMS confirmation with details of the reward, its value, and their updated points balance.</p>
            <Link className="btn px-4 py-2 rounded-pill mt-3 heroBtn" to="/signin">Redeem customer Points</Link>
          </div>
          <div className='features1Child23 d-none d-lg-block'>
            <img src={wanadamu3} alt="" />
          </div>
        </div>

        <div className='features1'>
          <div className='features1Child22'>
            <img src={wanadamu4} alt="" />
          </div>
          <div className='features1Child3 card p-4'>
            <h1>4. Send Bulk SMS with offers</h1>
            <p className='text-muted'>Turn visits into habits by surprising your customers with exciting offers. With Kuza Points, you can create special promotions, like double points days, birthday rewards, or exclusive member deals to keep them coming back. You can send these offers via bulk SMS, complete with your business name using an optional Sender ID for a branded experience. Whether it's a festive offer, a flash reward, or a VIP bonus, you're in control of how and when you engage. Build stronger relationships and boost repeat business effortlessly.</p>
            <Link className="btn px-4 py-2 rounded-pill mt-3 heroBtn" to="/signin">Send your Customers a bulk SMS</Link>
          </div>
        </div>

        <div className='features1'>
          <div className='features1Child card p-4'>
            <h1>5. Track Everything</h1>
            <p className='text-muted'>Kuza Points gives you a powerful dashboard to monitor customer activity, points issued, redemptions, and campaign performance — all in one place. Know who your most loyal customers are, see which offers drive the most engagement, and track the exact times and days your repeat customers come back most often.</p>

            <p className='text-muted'>What days are busiest? What time of day do your top customers visit? Use these insights to plan better promotions, manage staff schedules, and maximize your sales potential.</p>
            <p className='text-muted'>No guesswork just clear, actionable analytics that help you grow with confidence.</p>
            <Link className="btn px-4 py-2 rounded-pill mt-3 heroBtn" to="/signin">Sign up your Business</Link>
          </div>
          <div className='features1Child23'>
            <img src={wanadamu5} alt="" />
          </div>
        </div>
      </section>



      <section className='middleStuff'>
        <video src="https://res.cloudinary.com/ubunifu/video/upload/v1751317979/12659642-hd_1920_1080_30fps_jmh1qn.mp4" muted autoPlay loop></video>
        <div className='opacity'></div>
        <div className='playVideoCont'><FontAwesomeIcon icon={faPlay} className="playVideoIcon" /></div>
      </section>


      <section className='downloadApps' id='downloads'>
        <h1>Download Our Apps</h1>
        <hr />
        <p>Take your loyalty program with you, whether you're at the counter, on the floor, or on the go.
        With the Kuza Points App, you can effortlessly reward customers, track points, and manage redemptions in real-time.</p>
        <div className='downloadIcons'>
          <Link to="/dashboard"><img src={download1} alt="" /></Link> 
          <a href="https://play.google.com/store/apps/details?id=com.kuza.points&pli=1"><img src={download2} alt="" /></a>    
          <Link to="/dashboard"><img src={download3} alt="" /></Link> 
          {/* <Link to="/"><img src={download4} alt="" /></Link>  */}
        </div>

      </section>


      <section className='contactUs' id='contact'>
        <div className='contactUs1'>
            <h1>Contact <br />Us</h1>
        </div>

        <div className='contactUs2'>


          <div className='contactUs3'>
            <FontAwesomeIcon icon={faLocationDot} className='contactUs3Icon' />
            <div>
              <h4>Our Location</h4>
              <p>4th Floor, Paramount Plaza<br/>Nairobi, Kenya</p>
            </div>
          </div>

          <div className='contactUs3'>
            <FontAwesomeIcon icon={faPhone} className='contactUs3Icon' />
            <div>
              <h4>Call Us</h4>
              <p>0795156925</p>
            </div>
          </div>

          <div className='contactUs3'>
            <FontAwesomeIcon icon={faEnvelope} className='contactUs3Icon' />
            <div>
              <h4>Email</h4>
              <p>hello["@"]kuzapoints.com</p>
            </div>
          </div>

        <div className='col-12 mt-4'>
          <h6 className='fw-bold'>Follow Us</h6>
          <div className='d-flex gap-3 mt-2'>
            <a href="https://www.tiktok.com/@kuzapoints" target="_blank" rel="noreferrer" className='text-light fs-5'>
              <FontAwesomeIcon icon={faTiktok} />
            </a>
            <a href="https://instagram.com/kuzapoints" target="_blank" rel="noreferrer" className='text-light fs-5'>
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://facebook.com/kuzapoints" target="_blank" rel="noreferrer" className='text-light fs-5'>
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://twitter.com/kuzapoints" target="_blank" rel="noreferrer" className='text-light fs-5'>
              <FontAwesomeIcon icon={faTwitter} />
            </a>          
          </div>
        </div>


        </div>
        
      </section>


     <section className='footer text-center'>
      <p className='mb-0 text-muted'>
        &copy; {new Date().getFullYear()} Kuza Points. All Rights Reserved. Powered by <strong>Ubunifu College</strong>.
      </p>
    </section>


      

      
    </div>
  )
}

export default Home